import {IllustratedMessage} from '../../ui/images/illustrated-message';
import {SvgImage} from '../../ui/images/svg-image/svg-image';
import notifySvg from './notify.svg';
import {Trans} from '../../i18n/trans';
import {Button} from '../../ui/buttons/button';
import {Link} from 'react-router-dom';
import {useSettings} from '../../core/settings/use-settings';

export function NotificationEmptyStateMessage() {
  const {notif} = useSettings();
  return (
    <IllustratedMessage
      size="sm"
      title={<Trans message="No Notifications" />}
      description={
        <Trans message="You dont have any notifications currently. Make sure you check the notification settings below for your desired preference." />
      }
      action={
        notif.subs.integrated && (
          <Button
            elementType={Link}
            variant="outline"
            to="/notifications/settings"
            size="xs"
            color="primary"
          >
            <Trans message="Notification settings" />
          </Button>
        )
      }
    />
  );
}
